/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest
 */
export interface FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest {
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest
     */
    InviteToken: string;
}

/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest(value: object): value is FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest {
    if (!('InviteToken' in value) || value['InviteToken'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequestFromJSON(json: any): FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest {
    return FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequestFromJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'InviteToken': json['InviteToken'],
    };
}

export function FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequestToJSON(json: any): FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest {
    return FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequestToJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequestToJSONTyped(value?: FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'InviteToken': value['InviteToken'],
    };
}

